export function twoFactorStatusKey(twoFactor) {
    const status = twoFactor?.status;
    if (["no_account", "inactive", "no_web_access"].includes(status)) {
        return `com.file.contacts.two-factor-status-${status.replaceAll("_", "-")}`;
    }

    if (twoFactor?.requiresReenrollment) {
        return "com.file.contacts.two-factor-status-reenrollment";
    }

    return twoFactor?.isEnabled
        ? "com.file.contacts.two-factor-status-configured"
        : "com.file.contacts.two-factor-status-not-configured";
}

// Keep detailed recovery-code statistics and history out of contact list state.
export function twoFactorSummary(details) {
    return {
        userId: details.userId,
        status: details.status,
        isEnabled: details.isEnabled,
        requiredByTenant: details.requiredByTenant,
        requiredByUser: details.requiredByUser,
        requiresReenrollment: details.requiresReenrollment,
        isRequired: details.isRequired,
        canManage: details.canManage,
    };
}
